// Year navigation for the reconciliation page. Nothing here is fixed to a
// year: "this year" comes from today's date and the list comes from the data.

export const thisYear = (now = new Date()) => now.getFullYear();

// Reads ?year= from a query string; anything invalid or in the future falls back to this year.
export function yearFromSearch(search, now = new Date()) {
  const raw = new URLSearchParams(search || '').get('year');
  const n = Number(raw);
  return raw && Number.isInteger(n) && n >= 1900 && n <= thisYear(now) ? n : thisYear(now);
}

// Writes ?year= back into the address bar without a reload, keeping other params.
export function writeYearToUrl(year, win = typeof window !== 'undefined' ? window : null) {
  if (!win || !win.history || !win.location) return;
  const params = new URLSearchParams(win.location.search);
  if (params.get('year') === String(year)) return;
  params.set('year', String(year));
  win.history.replaceState(win.history.state, '', `${win.location.pathname}?${params.toString()}${win.location.hash || ''}`);
}

const yearOf = (v) => {
  const n = Number(String(v || '').slice(0, 4));
  return Number.isInteger(n) && n >= 1900 ? n : null;
};

// Every year from the earliest year any account has data (first activity or
// opening balance) through this year, plus the year being shown. Never a future year. Newest first.
export function yearOptions(accounts, shown, now = new Date()) {
  const current = thisYear(now);
  const found = (accounts || []).flatMap((a) => [yearOf(a.first_activity_month), yearOf(a.opening_balance_date)]).filter(Boolean);
  const start = Math.min(current, shown || current, ...found.filter((y) => y <= current));
  const end = current;
  const out = [];
  for (let y = end; y >= start; y -= 1) out.push(y);
  return out;
}